import { setData } from '@/actions/auth';
import {
  deleteRooms,
  editRooms,
  getRoomBySlug,
  migrateCourseUsersRequest,
} from '@/actions/room';
import FormDataHelper from '@/helpers/formDataHelper';
import useWidth from '@/helpers/widthUtil';
import { Button, notification, Popconfirm } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EditOutlined } from '@ant-design/icons';
import RoomForm from '../room-form';
import { useRouter } from 'next/router';

const RoomSettings = ({ roomData }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const { isMobile } = useWidth();
  const router = useRouter();

  const [isEditSettings, setEditSettings] = useState(false);
  const [migrateClick, setMigrateClick] = useState(false);

  const migrateCourseUsersStatus = useSelector(
    (state: any) => state.roomReducer.migrateCourseUsersStatus
  );
  const rooms = useSelector((state: any) => state.roomReducer?.rooms);
  const roomSlugData = useSelector(
    (state: any) => state.roomReducer?.roomDetail?.data
  );
  const user = useSelector((state: any) => state.auth?.creds?.user_data);

  useEffect(() => {
    return () => {
      setMigrateClick(false);
      setEditSettings(false);
    };
  }, []);

  useEffect(() => {
    if (router?.query?.tab === 'settings') {
      dispatch(getRoomBySlug(roomData?.slug));
    }
  }, [router?.query?.tab]);

  useEffect(() => {
    if (migrateClick && migrateCourseUsersStatus == 'success') {
      notification.success({
        message: 'Processing to migrate all users to the room.',
      });
      setMigrateClick(false);
    } else if (migrateCourseUsersStatus == 'failure') {
      notification.error({ message: 'Failed to migrate' });
    }
  }, [migrateCourseUsersStatus]);

  useEffect(() => {
    if (rooms?.updateSuccess) {
      notification.success({ message: `Successfully updated.` });
      roomData && dispatch(getRoomBySlug(roomData?.slug));
      setEditSettings(false);
    }

    clearState();
  }, [rooms?.updateSuccess]);

  useEffect(() => {
    clearState();
  }, []);

  const clearState = () => {
    // updateSuccess
    dispatch(
      setData({
        name: 'rooms',
        key: 'updateSuccess',
        value: false,
      })
    );
  };

  const handleDelete = (e: any, slug: any) => {
    e.preventDefault();
    dispatch(deleteRooms(slug));
  };

  const onEditFinish = (values) => {
    let value;
    if (file) {
      value = FormDataHelper(values, { image: file });
    } else {
      dispatch(editRooms(values, roomData?.slug));
      return;
    }
    dispatch(editRooms(value, roomData?.slug));
  };

  const normFile = (e: any) => {
    if (file === null) {
      setFile(e.target.files[0]);
    }
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  const migrateData = () => {
    setMigrateClick(true);

    dispatch(
      migrateCourseUsersRequest({
        data: { course: roomData.course.id, room: roomData.slug },
      })
    );
  };

  return (
    <>
      <div className={`col-lg-12 col-md-10 col-sm-12 ${isMobile && 'px-0'}`}>
        <div
          className="bg-white p-4"
          style={{ borderRadius: '8px', boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)' }}
        >
          <div className="d-flex justify-content-between flex-wrap align-items-center ">
            <h5 className="heading">Settings</h5>
            <div className="bg-primary text-white rounded-circle d-flex justify-content-center align-items-center p-2">
              <EditOutlined
                rev=""
                style={{ fontSize: '20px' }}
                className="cursor-pointer"
                onClick={() => setEditSettings(true)}
              />
            </div>
          </div>

          <div
            className="justify-content-start border-0"
            style={{ backgroundImage: 'none !important' }}
          >
            <RoomForm
              onEditFinish={onEditFinish}
              normFile={normFile}
              roomData={roomSlugData}
              rooms={rooms}
              isEditSettings={isEditSettings}
            />
          </div>

          {roomData?.course !== null && roomData?.room_type === 1 && isMobile && (
            <Button className="btn-secondary border-danger" onClick={migrateData}>
              Migrate All Course Students
            </Button>
          )}

          {(user?.user_type === 'staff' ||
            (user?.user_type === 'instructor' &&
              roomData?.created_by === user?.id)) && (
            <div className="mt-4">
              <h4 className="text-danger">Delete this Room!</h4>
              <Popconfirm
                title="Are you absolutely sure?"
                onConfirm={(e) => handleDelete(e, roomData?.slug)}
                okText="Confirm"
              >
                <Button
                  className="border-danger text-danger "
                  style={{ borderRadius: '5px' }}
                >
                  Delete room
                </Button>
              </Popconfirm>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RoomSettings;
